import React from 'react'
import vulnyticslogo  from '../../Assests/buglogo.png'
import './Page-css/ClientNavbar1.css'

function ClientNavbar1() {

  return (
    <div className='top_logo_navbar'>
      <div className='vulnytics_logo_nav'>
        <img src={vulnyticslogo} alt='Vulnytics-Pentesting As a Service'/>
      </div>
    </div>
  )
}

export default ClientNavbar1
